import React, { useEffect, useState } from "react";
import HelpPanel from "@cloudscape-design/components/help-panel";

import VariationsTable from "./components/listUser";

import { ListUser, variationsData } from "./data/data";
import {
  AppLayout,
  Box,
  BreadcrumbGroup,
  ContentLayout,
  Header,
  Icon,
  Link,
  Spinner,
  SplitPanel,
} from "@cloudscape-design/components";

import { Navigation } from "../../../components/app/Navigation";
// import '@cloudscape-design/global-styles/index.css'

import { listAdmins } from "../../../graphql/queries";
import { Amplify } from "aws-amplify";
import { generateClient } from "aws-amplify/api";
import config from "../../../amplifyconfiguration.json";
import { ListAdminsQueryVariables } from "../../../API";

const client = generateClient()
Amplify.configure(config);

export default function AdminListUser() {
  const [activeHref, setActiveHref] = React.useState("/admin/users");
  const [helpPanelOpen, setHelpPanelOpen] = useState(false); // State untuk mengontrol panel bantuan
  const [listUser, setListUser] = useState<ListUser[]>([]);
  const [isLoading, setIsLoading] = React.useState(true);

  useEffect(() => {
    fetchAdmins();
  }, []);

  async function fetchAdmins(limit = 100) {
    try {
      let nextToken: string | null = null;
      let allAdmins: ListUser[] = [];
      do {
        const variables: ListAdminsQueryVariables = { limit, nextToken };
        let response = await client.graphql({
          query: listAdmins,
          authMode : 'userPool',
          variables,
        });
        const admins = response.data.listAdmins.items;
        nextToken = response.data.listAdmins.nextToken ?? null;

        const newAdmins: ListUser[] = admins.map((admin:any) => {
          const formattedTimestamp = new Date(admin.updatedAt).toLocaleString();
          return {
            id: admin["id"],
            NIK: admin["nik"] ?? "",
            Name:admin["name"] ?? "",
            Email: admin["email"] ?? "",
            Position: admin["position"] ?? "",
            tenant: admin["tenant"] ?? "",
            Username: admin["username"] ?? "",
            Password: admin["password"] ?? "",
            AccessRole: admin["accessrole"] ?? "",
            Timestamps: formattedTimestamp??"",
          };
      });
        allAdmins=[...allAdmins, ...newAdmins];
      }while (nextToken);

      setListUser(allAdmins);
      setIsLoading(false);
    } catch (err) {
      console.log("error fetching user : ", err);
    }

  }

  return (
    <>
      <AppLayout
        breadcrumbs={
          <BreadcrumbGroup
            items={[
              {
                text: "Admin",
                href: "/admin",
              },
              {
                text: "User Detail",
                href: "/admin/users",
              },
            ]}
          />
        }
        navigation={
          <Navigation
            activeHref={activeHref}
            setActiveHref={setActiveHref}
            adminSubMenuOpen={false}
            setAdminSubMenuOpen={function (href: boolean): void {
              throw new Error("Function not implemented.");
            }} // adminSubMenuOpen={adminSubMenuOpen} // Mengirim state submenu Admin ke komponen Navigation
          // setAdminSubMenuOpen={setAdminSubMenuOpen} // Mengirim fungsi untuk mengubah state submenu Admin ke komponen Navigation
          />
        }
        //navigationOpen={true}
        //   navigation={
        //     <Navigation activeHref={activeHref} setActiveHref={setActiveHref} />
        //   }
        //notifications={
        //  <Flashbar
        //    items={[
        //      {
        //        type: "info",
        //        dismissible: true,
        //        content: "This is an info flash message.",
        //        id: "message_1",
        //      },
        //    ]}
        //  />
        //}
        toolsOpen={helpPanelOpen} // Menggunakan state untuk menentukan apakah panel bantuan terbuka atau tidak
        onToolsChange={() => setHelpPanelOpen(!helpPanelOpen)}
        tools={
          <HelpPanel
            footer={
              <div>
                <h3>
                  Learn more <Icon name='external' />
                </h3>
                <ul>
                  <li>
                    <a href=''>Link to documentation</a>
                  </li>
                  <li>
                    <a href=''>Link to documentation</a>
                  </li>
                </ul>
              </div>
            }
            header={<h2>Help panel title (h2)</h2>}
          >
            <div>
              <p>
                This is a paragraph with some <b>bold text</b> and also some{" "}
                <i>italic text</i>.
              </p>

              <h3>h3 section header</h3>
              <ul>
                <li>Unordered list item.</li>
                <li>Unordered list item.</li>
              </ul>

              <h4>h4 section header</h4>
              <p>
                Code can be formatted as lines of code or blocks of code. Add
                inline code <code>like this</code> using a{" "}
                <code>{"<code>"}</code> tag.
                <pre>
                  Or format blocks of code (like this) using a{" "}
                  <code>{"<pre>"}</code> tag.
                </pre>
              </p>

              <h5>h5 section header</h5>
              <dl>
                <dt>This is a term</dt>
                <dd>This is its description.</dd>
                <dt>This is a term</dt>
                <dd>This is its description</dd>
              </dl>
            </div>
          </HelpPanel>
        }
        content={
          <ContentLayout
            header={
              <Header
                variant='h1'
                info={
                  <Link
                    variant='info'
                    onFollow={() => setHelpPanelOpen(!helpPanelOpen)}
                  >
                    Info
                  </Link>
                }
              >
                {activeHref === "/admin/users" ? `User Detail ` : ""}
              </Header>
            }
          >
            <div className='contentPlaceholder' style={{marginTop: isLoading ? '160px' : '0px'}}>
            {isLoading ? (
                <Box textAlign='center'>
                  <Spinner size='large' />
                  <Box variant='p'>Loading users data...</Box>
                </Box>
              ) : (
                <VariationsTable ListUser={listUser} refreshData={fetchAdmins} />
              )}
              
            </div>
          </ContentLayout>
        }
        splitPanel={
          <SplitPanel header='Split panel header'>
            Split panel content
          </SplitPanel>
        }
      />
    </>
  );
}